export default {
    buttons: {
        save: 'Save',
    },
    fields: {
        phone: {
            label: 'Phone number',
            placeholder: '+3811231231',
        },
    },
    errors: {
        user_resend_limit_reached_contact_support: 'Resend limit reached contact support!',
        user_resend_limit_reached: 'Resend limit reached, please try again after 15 minutes!',
        user_mobile_already_verified: 'This phone number is already verified',
        user_resend_spam_detected: 'Resend limit reached contact support!',
    },
}
